/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");
import Vuetify from "vuetify";
import * as VueGoogleMaps from "gmap-vue";

import VueGooglePlaces from 'vue-google-places'

import axios from "axios";
import _ from "lodash";

import Vue from "vue";

// var console = {};
// console.log = function() {};
// window.console = console;


// window.Vue = require("vue");

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component("burger-menu", require("./components/BurgerMenu.vue").default);
// Vue.component("new-ideas", require("./components/NewIdeas.vue").default);
Vue.component(
    "infinite-horizontal",
    require("./components/InfiniteScrollHorizontal.vue").default
);
Vue.component("scroll-link", require("./components/ScrollLink.vue").default);
Vue.component(
    "autocomplete",
    require("./components/SearchAutocomplete.vue").default
);
Vue.component(
    "idea-container",
    require("./components/IdeaContainer.vue").default
);
Vue.component("idea-listing", require("./components/IdeaListing.vue").default);
Vue.component("idea-page", require("./components/IdeaPage.vue").default);
Vue.component("idea-create", require("./components/IdeaCreate.vue").default);
Vue.component("idea-edit", require("./components/IdeaEdit.vue").default);
Vue.component(
    "idea-suggestion",
    require("./components/IdeaSuggestion.vue").default
);
Vue.component(
    "idea-grid-item",
    require("./components/IdeaGridItem.vue").default
);
Vue.component(
    "idea-list-item",
    require("./components/IdeaListItem.vue").default
);
Vue.component(
    "rating-component",
    require("./components/RatingComponent.vue").default
);

Vue.component(
    "carousel-component",
    require("./components/CarouselComponent.vue").default
);

Vue.component("file-drop", require("./components/FileDrop.vue").default);
Vue.component("google-maps", require("./components/GoogleMaps.vue").default);
Vue.component("idea-map", require("./components/IdeaMap.vue").default);

//Settings

Vue.component(
    "settings-profile",
    require("./components/settings/Profile.vue").default
);
Vue.component(
    "settings-email",
    require("./components/settings/Email.vue").default
);
Vue.component(
    "settings-password",
    require("./components/settings/Password.vue").default
);

Vue.component(
    "settings-notification",
    require("./components/settings/Notifications.vue").default
);

Vue.component(
    "settings-created",
    require("./components/settings/CreatedIdeas.vue").default
);

Vue.component(
    "settings-edited",
    require("./components/settings/EditedIdeas.vue").default
);

//CREATION

Vue.component(
    "category-tabs",
    require("./components/create/CategoryTabs.vue").default
);
Vue.component(
    "creation-duration",
    require("./components/create/Duration.vue").default
);
Vue.component(
    "creation-amount",
    require("./components/create/Amount.vue").default
);
Vue.component(
    "creation-price",
    require("./components/create/Price.vue").default
);
Vue.component(
    "creation-preperation",
    require("./components/create/Preperation.vue").default
);
Vue.component(
    "creation-location",
    require("./components/create/Location.vue").default
);
Vue.component("creation-age", require("./components/create/Age.vue").default);
Vue.component(
    "creation-infrastructure",
    require("./components/create/Infrastructure.vue").default
);
Vue.component(
    "creation-geolocation",
    require("./components/create/Geolocation.vue").default
);

Vue.component(
    "creation-images",
    require("./components/create/Images.vue").default
);

Vue.component(
    "creation-pdf",
    require("./components/create/Pdf.vue").default
);
Vue.component(
    "creation-materials",
    require("./components/create/Materials.vue").default
);
Vue.component(
    "creation-objectives",
    require("./components/create/Objectives.vue").default
);
//FILTERS

Vue.component("idea-filters", require("./components/IdeaFilters.vue").default);
Vue.component(
    "filter-age",
    require("./components/filters/AgeFilter.vue").default
);
Vue.component(
    "filter-amount",
    require("./components/filters/AmountFilter.vue").default
);
Vue.component(
    "filter-cost",
    require("./components/filters/CostFilter.vue").default
);
Vue.component(
    "filter-date",
    require("./components/filters/DateFilter.vue").default
);
Vue.component(
    "filter-duration",
    require("./components/filters/DurationFilter.vue").default
);
Vue.component(
    "filter-location",
    require("./components/filters/LocationFilter.vue").default
);
Vue.component(
    "filter-preperation",
    require("./components/filters/PreperationFilter.vue").default
);
Vue.component(
    "filter-local",
    require("./components/filters/LocalFilter.vue").default
);
Vue.component(
    "filter-infra",
    require("./components/filters/InfraFilter.vue").default
);
Vue.component(
    "filter-type",
    require("./components/filters/TypeFilter.vue").default
);
Vue.component(
    "filter-geolocation",
    require("./components/filters/Geolocation.vue").default
);
Vue.component("filter-objectives", require("./components/filters/ObjectiveFilter.vue").default);
Vue.component("InfiniteLoading", require("vue-infinite-loading").default);
// Vue.component("SocialSharing", require("vue-social-sharing"));
Vue.component("vue-dropzone", require("vue2-dropzone"));

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.use(Vuetify);

var r = {
    baidu: "http://cang.baidu.com/do/add?iu=@u&it=@t",
    buffer: "https://bufferapp.com/add?text=@t&url=@u",
    email: "mailto:?subject=@t&body=@u%0D%0A@d",
    evernote: "https://www.evernote.com/clip.action?url=@u&title=@t",
    facebook:
        "https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h",
    flipboard:
        "https://share.flipboard.com/bookmarklet/popout?v=2&url=@u&title=@t",
    hackernews: "https://news.ycombinator.com/submitlink?u=@u&t=@t",
    instapaper: "http://www.instapaper.com/edit?url=@u&title=@t&description=@d",
    line: "http://line.me/R/msg/text/?@t%0D%0A@u%0D%0A@d",
    linkedin: "https://www.linkediwindow.com/sharing/share-offsite/?url=@u",
    odnoklassniki:
        "https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=@u&st.comments=@t",
    pinterest:
        "https://pinterest.com/pin/create/button/?url=@u&media=@m&description=@t",
    pocket: "https://getpocket.com/save?url=@u&title=@t",
    quora: "https://www.quora.com/share?url=@u&title=@t",
    reddit: "https://www.reddit.com/submit?url=@u&title=@t",
    skype: "https://web.skype.com/share?url=@t%0D%0A@u%0D%0A@d",
    sms: "sms:?body=@t%0D%0A@u%0D%0A@d",
    stumbleupon: "https://www.stumbleupowindow.com/submit?url=@u&title=@t",
    telegram: "https://t.me/share/url?url=@u&text=@t%0D%0A@d",
    tumblr: "https://www.tumblr.com/share/link?url=@u&name=@t&description=@d",
    twitter: "https://twitter.com/intent/tweet?text=@t&url=@u&hashtags=@h@tu",
    viber: "viber://forward?text=@t%0D%0A@u%0D%0A@d",
    vk:
        "https://vk.com/share.php?url=@u&title=@t&description=@d&image=@m&noparse=true",
    weibo: "http://service.weibo.com/share/share.php?url=@u&title=@t&pic=@m",
    whatsapp: "https://api.whatsapp.com/send?text=@t%0D%0A@u%0D%0A@d",
    wordpress: "https://wordpress.com/press-this.php?u=@u&t=@t&s=@d&i=@m",
    xing: "https://www.xing.com/app/user?op=share&url=@u&title=@t",
    yammer:
        "https://www.yammer.com/messages/new?login=true&status=@t%0D%0A@u%0D%0A@d"
};

var component = {
    name: "SocialSharing",
    props: {
        network: {
            type: String,
            required: !0
        },
        url: {
            type: String,
            required: !0
        },
        title: {
            type: String,
            required: !0
        },
        description: {
            type: String,
            default: ""
        },
        quote: {
            type: String,
            default: ""
        },
        hashtags: {
            type: String,
            default: ""
        },
        twitterUser: {
            type: String,
            default: ""
        },
        media: {
            type: String,
            default: ""
        },
        tag: {
            type: String,
            default: "a"
        }
    },
    data: function () {
        return {
            popup: {
                width: 626,
                height: 436,
                top: 0,
                left: 0,
                window: void 0,
                interval: null
            }
        };
    },
    computed: {
        networks: function () {
            return this.$SocialSharing
                ? this.$SocialSharing.options.networks
                : r;
        },
        key: function () {
            return this.network.toLowerCase();
        },
        rawLink: function () {
            var t = navigator.userAgent.toLowerCase();
            return "sms" === this.key &&
            (t.indexOf("iphone") > -1 || t.indexOf("ipad") > -1)
                ? this.networks[this.key].replace(":?", ":&")
                : this.networks[this.key];
        },
        shareLink: function () {
            var t = this.rawLink;
            return (
                "twitter" === this.key &&
                (this.hashtags.length ||
                (t = t.replace("&hashtags=@h", "")),
                this.twitterUser.length || (t = t.replace("@tu", ""))),
                    t
                        .replace(
                            /@tu/g,
                            "&via=" + encodeURIComponent(this.twitterUser)
                        )
                        .replace(/@u/g, encodeURIComponent(this.url))
                        .replace(/@t/g, encodeURIComponent(this.title))
                        .replace(/@d/g, encodeURIComponent(this.description))
                        .replace(/@q/g, encodeURIComponent(this.quote))
                        .replace(/@h/g, this.encodedHashtags)
                        .replace(/@m/g, encodeURIComponent(this.media))
            );
        },
        encodedHashtags: function () {
            return "facebook" === this.key && this.hashtags.length
                ? "%23" + this.hashtags.split(",")[0]
                : this.hashtags;
        }
    },
    render: function (t) {
        var e = this;
        if (!this.networks.hasOwnProperty(this.key))
            throw new Error("Network " + this.key + " does not exist");
        return t(
            this.tag,
            {
                class: "share-network-" + this.key,
                on: {
                    click: function () {
                        return e[
                            "http" === e.rawLink.substring(0, 4)
                                ? "share"
                                : "touch"
                            ]();
                    }
                }
            },
            this.$slots.default
        );
    },
    methods: {
        resizePopup: function () {
            var t =
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    window.screenX,
                e =
                    window.innerHeight ||
                    document.documentElement.clientHeight ||
                    window.screenY,
                i = t / window.screen.availWidth;
            (this.popup.left =
                (t - this.popup.width) / 2 / i +
                (void 0 !== window.screenLeft
                    ? window.screenLeft
                    : window.screenX)),
                (this.popup.top =
                    (e - this.popup.height) / 2 / i +
                    (void 0 !== window.screenTop
                        ? window.screenTop
                        : window.screenY));
        },
        share: function () {
            var t = this;
            this.resizePopup(),
            this.popup.window &&
            this.popup.interval &&
            (clearInterval(this.popup.interval),
                this.popup.window.close(),
                this.emit("change")),
                (this.popup.window = window.open(
                    this.shareLink,
                    "sharer",
                    ",height=" +
                    this.popup.height +
                    ",width=" +
                    this.popup.width +
                    ",left=" +
                    this.popup.left +
                    ",top=" +
                    this.popup.top +
                    ",screenX=" +
                    this.popup.left +
                    ",screenY=" +
                    this.popup.top
                )),
                this.popup.window.focus(),
                (this.popup.interval = setInterval(function () {
                    (t.popup.window && !t.popup.window.closed) ||
                    (clearInterval(t.popup.interval),
                        (t.popup.window = null),
                        t.emit("close"));
                }, 500)),
                this.emit("open");
        },
        touch: function () {
            window.open(this.shareLink, "_blank"), this.emit("open");
        },
        emit: function (t) {
            this.$root.$emit("share_network_" + t, this.key, this.url),
                this.$emit(t, this.key, this.url);
        }
    }
};

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBIopeK9JwmDX2XNzoTGKIc5crgNo8OLE0",
        libraries: "places" // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'gmap-vue/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true
});

const app = new Vue({
    el: "#app",
    vuetify: new Vuetify({
        // theme: { disable: true }
    }),
    components: {
        "social-sharing": component
    }
});
let showSocial = false;
let st = document.querySelector("#social-toggle");
st &&
st.addEventListener("click", function () {
    showSocial = !showSocial;
    if (showSocial) {
        document.querySelector("#social-wrapper").style.display = "block";
    } else {
        document.querySelector("#social-wrapper").style.display = "none";
    }
});
